/* eslint-disable camelcase */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import MembershipPrices from './membership-prices';
import makeSelectAppointment from '../Appointment/selectors';

class MemershipBenefits extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.editMembershipPlainId = this.editMembershipPlainId.bind(this);
  }
  editMembershipPlainId(stripePlan) {
    if (stripePlan && stripePlan.includes('v2')) {
      return stripePlan.slice(0, stripePlan.length - 2);
    }
    return stripePlan;
  }
  render() {
    const { locationServices } = this.props.appointmentData;
    const { services } = locationServices;
    return (
      <div className="select-service__include">
        {!this.props.isMember && (
          <p className="select-service__description mbpt0 mbmb0 hide-desktop">
            plus each massage includes your choice of deep tissue, heat therapy,
            aromatherapy and percussion therapy at no extra cost.
          </p>
        )}
        <div>
          <i
            className={`icon-membership icon-membership--smiley-small ${
              this.props.phase3 ? '' : 'hide-phone'
            }`}
          />
        </div>
        <div className="hdg-wave phone-only">
          <i className="icon icon--squiggle hdg-wave__icon" />
          <span className="hdg-wave__text">
            <i className="icon-membership icon-membership--smiley-small phoneGiftingDetailsSmily" />
          </span>
        </div>
        <div className={`hdg-wave ${this.props.phase3 ? '' : 'hide-phone'}`}>
          <i className="icon icon--squiggle hdg-wave__icon" />
          <span
            className={`hdg-wave__text ${
              this.props.phase3 ? '' : 'hide-phone'
            }`}
          >
            membership benefits{' '}
            {!this.props.phase3 && <Fragment>include</Fragment>}
          </span>
        </div>
        <div
          className={`noObligation ${this.props.phase3 ? '' : 'hide-phone'}`}
        >
          (No obligations, you can{' '}
          <span className="phone-only">
            <br />
          </span>
          cancel at any time!)
        </div>
        <p className="membersReveiveTextMobile phone-only">
          {this.props.isMember ? 'your current perks' : 'members receive'}
        </p>
        <p className="select-service__info phone-only">
          {!this.props.isMember && (
            <p className="membershipMemberRecive">
              {this.props.phase3 && <Fragment>You get </Fragment>}one member{' '}
              <br /> massage each month,
              <span className="show">
                plus discounted member rates on additional massages:
              </span>
            </p>
          )}
          {this.props.isMember && (
            <span>
              <span className="show">
                {`One ${this.editMembershipPlainId(
                  this.props.membershipDetails.stripe_plan_id,
                )} each month`}
              </span>{' '}
              plus discounted member rates on additional massages:
            </span>
          )}
        </p>
        <p className="select-service__info hide-phone">
          <span>
            <span>
              {this.props.phase3
                ? `You get one member massage every month, `
                : `One member massage each month,`}
            </span>
            plus discounted member rates on additional massages:
          </span>
        </p>
        <MembershipPrices services={services} />
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  appointmentData: makeSelectAppointment(),
});

const withConnect = connect(
  mapStateToProps,
  {},
);

MemershipBenefits.propTypes = {
  isMember: PropTypes.bool,
  membershipDetails: PropTypes.object,
  appointmentData: PropTypes.object,
  phase3: PropTypes.bool,
};

export default compose(withConnect)(MemershipBenefits);
